export class UnwrapException extends Error {
  constructor(details?: string) {
    super('UnwrapException' + (details ?? ' '));

    // Set the prototype explicitly.
    Object.setPrototypeOf(this, UnwrapException.prototype);
  }
}
